
import { FormsFeatureContext } from '@ngt/forms';
import { useCallback, useContext } from 'react';
import { ReportCustomTemplateField, ReportTemplate, ReportTemplatePostSave, ReportTemplatePostSaveResponse } from '../../api/dtos';

export const usePostReportTemplateSave = () => {
    const formsFeature = useContext(FormsFeatureContext);
    
    // @ts-ignore
    const save = useCallback(async (reportTemplate?: ReportTemplate, fields?: ReportCustomTemplateField[]) => {
        if(!reportTemplate) return false;
        const response: ReportTemplatePostSaveResponse = await formsFeature.serviceStackClient.post(new ReportTemplatePostSave({ template: reportTemplate, fields: fields}))

        return response.responseStatus;
    }, [formsFeature.serviceStackClient]);

    return save;
};

export default usePostReportTemplateSave;